const CALENDAR_DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;
const EXACT_CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Year, month (1-12) and day of a `YYYY-MM-DD` value, read straight from the text (never through a
 * timezone-shifting `Date`). Null when unreadable or impossible (Feb 31). `exact: false` also accepts a
 * longer value that starts with the date (e.g. an ISO timestamp).
 */
export function parseCalendarDateParts(
  value: string,
  { exact }: { exact: boolean }
): { year: number; month: number; day: number } | null {
  const trimmed = value.trim();
  if (exact && !EXACT_CALENDAR_DATE.test(trimmed)) return null;
  const match = CALENDAR_DATE_PREFIX.exec(trimmed);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1) return null;
  // Calendar-valid only: Date.UTC rolls an impossible day (Feb 31) into the next month.
  if (new Date(Date.UTC(year, month - 1, day)).getUTCDate() !== day) return null;
  return { year, month, day };
}
